import Web3 from "web3";
import bs58 from "bs58";
import { generateNonce, SiweMessage } from "siwe";
import { appPrefixedHostWithProtocol } from "@novel/shared/utils/appDomainConstants";
import { getAddress } from "ethers/lib/utils";
import { SolanaProvider } from "@novel/shared/utils/wallets/walletLibInstances";
interface SignedResult {
    unsignedMessage: string;
    signatureNonce: string;
    signedMessage: string;
}

export async function getSignedEvmMessage(web3: Web3, address: string): Promise<SignedResult> {
    const { nonce, message } = createEvmSiweMessage(address);

    return {
        unsignedMessage: message,
        signatureNonce: nonce,
        signedMessage: await web3.eth.personal.sign(message, address, message),
    };
}

export async function getSignedSolanaMessage(
    provider: SolanaProvider,
    address: string,
): Promise<SignedResult> {
    const { message, nonce } = createSolanaSiweMessage(address);

    const encodedMessage = new TextEncoder().encode(message);
    const response = await provider.signMessage(encodedMessage, "utf8");

    return {
        unsignedMessage: message,
        signatureNonce: nonce,
        signedMessage: bs58.encode(response.signature),
    };
}

function createSolanaSiweMessage(address: string) {
    const siweMessage = createSiweMessage(address);
    return {
        nonce: siweMessage.nonce,
        message: siweMessage.message.replace("Ethereum", "Solana").replace("Chain ID: 1\n", ""),
    };
}

export function createEvmSiweMessage(address: string) {
    return createSiweMessage(getAddress(address));
}

function createSiweMessage(address: string): {
    nonce: string;
    message: string;
} {
    const nonce = generateNonce();
    const siweMessage = new SiweMessage({
        address,
        statement: "Sign below to authenticate with Novel",
        domain:
            typeof window !== "undefined"
                ? window.location.host
                : appPrefixedHostWithProtocol.replace("https://", ""),
        uri: typeof window !== "undefined" ? window.location.origin : appPrefixedHostWithProtocol,
        chainId: 1,
        version: "1", // allows manual busting, shouldn't need
        nonce,
    });

    return {
        nonce,
        message: siweMessage.prepareMessage(),
    };
}
